/**
 * Created by cheaphakdey on 1/2/19.
 */

export const orderList: string = '/order/list';
export const orderDetail: string = '/order/order-detail';
